import { Injectable } from "@angular/core";
import { QuoteService } from "@cai-services";
import { from, Observable } from "rxjs";
import { Message } from "../_models/message.model";

@Injectable({
  "providedIn": "root",
})
export class ChatMessageService {
  constructor (private readonly quoteService: QuoteService) {}

  public retrieveAllMessages (
    quoteId: number,
    token?: string
  ): Observable<Message[]> {
    return from(
      this.quoteService.retrieveAllMessages(quoteId, token) as Promise<
        Message[]
      >
    );
  }

  public createMessage (
    quoteId: number,
    body: Message,
    token?: string
  ): Observable<Message> {
    return from(
      this.quoteService.createMessage(quoteId, body, token) as Promise<Message>
    );
  }
}
